<template>
  <div class="new-visit-bottombar">
    <div class="m-container">
      <div class="new-visit-bottombar-inside">
        <BaseButton
          v-if="hasBack"
          variant="tertiary"
          @click="$router.back()"
        >
          Späť
        </BaseButton>
        <BaseButton
          v-if="hasContinue"
          variant="secondary"
          @click="$emit('continue')"
        >
          {{ continueButtonLabel }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script setup>
import BaseButton from '@/components/BaseButton.vue';

defineProps({
  hasBack: {
    type: Boolean,
  },
  hasContinue: {
    type: Boolean,
  },
  continueButtonLabel: {
    type: String,
    default: 'Pokračovať',
  },
});

defineEmits(['continue']);
</script>

<style scoped>
.new-visit-main {
  padding-bottom: 96px;
}

.new-visit-bottombar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  border-top: 1px solid var(--gray-200);
  padding: 24px 0 16px;
  box-shadow: var(--box-shadow-200);
  background-color: var(--white);
}

.base-button {
  max-width: calc(50% - 8px);
}

.new-visit-bottombar-inside {
  display: flex;
  gap: 16px;
}

</style>
